import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('basic-tabs', () => import(/* webpackMode: "lazy" */'./basic-tabs'));
